import { styled } from 'goober';

const CheckboxWrapper = styled('label')`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--text);
  cursor: pointer;
  padding: 2px 0;
  user-select: none;

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: default;
  }
`;

const Checkbox = styled('input')`
  margin: 0;
  cursor: pointer;
  accent-color: var(--accent);

  &:disabled {
    cursor: default;
  }
`;

interface FilterCheckboxProps {
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

export function FilterCheckbox({ checked, disabled, onChange }: FilterCheckboxProps) {
  return (
    <CheckboxWrapper data-disabled={disabled}>
      <Checkbox
        type="checkbox"
        checked={checked}
        disabled={disabled}
        data-testid="iso-filter-checkbox"
        onChange={(e: Event) => onChange((e.target as HTMLInputElement).checked)}
      />
      Afficher uniquement les points dans l'isochrone
    </CheckboxWrapper>
  );
}
